import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f7d759"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"margin-top":"20px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = {
  key: 0,
  style: {"color":"gray","font-size":"13px"}
}
const _hoisted_9 = { class: "wallet-remark2-cell" }
const _hoisted_10 = {
  key: 1,
  class: "wallet-verify-verified"
}
const _hoisted_11 = {
  key: 0,
  class: "wallet-verify-number"
}
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_x_dialog = _resolveComponent("x-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState,
        ref: "searchFormRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "userId",
            label: "用户ID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.userId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.userId) = $event)),
                placeholder: "请输入用户ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "type",
            label: "类型"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.type,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchFormState.type) = $event)),
                style: {"min-width":"120px"},
                placeholder: "请选择类型",
                "allow-clear": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("钱包")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("广告支出")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 3 }, {
                    default: _withCtx(() => [
                      _createTextVNode("广告消耗")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 4 }, {
                    default: _withCtx(() => [
                      _createTextVNode("购买反现")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "verify",
            label: "财务核验"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.verify,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchFormState.verify) = $event)),
                style: {"min-width":"140px"},
                placeholder: "请选择财务核验类型",
                "allow-clear": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("待核验")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("已经核验")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("核验错误")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "timeRange",
            label: "创建时间"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: $setup.searchFormState.timeRange,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($setup.searchFormState.timeRange) = $event)),
                "value-format": $setup.dateFormat,
                placeholder: ['开始日期', '结束日期'],
                "allow-clear": "",
                style: {"width":"260px"}
              }, null, 8, ["value", "value-format"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                loading: $setup.exportLoading,
                onClick: $setup.exportXls
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出 XLS")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 1400 }
      }, {
        type: _withCtx(({ scope }) => [
          ((scope.record as any).type === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createVNode(_component_a_tag, { color: "blue" }, {
                  default: _withCtx(() => [
                    _createTextVNode("钱包")
                  ]),
                  _: 1
                })
              ]))
            : ((scope.record as any).type === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_component_a_tag, { color: "orange" }, {
                    default: _withCtx(() => [
                      _createTextVNode("广告清零")
                    ]),
                    _: 1
                  })
                ]))
              : ((scope.record as any).type === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createVNode(_component_a_tag, { color: "red" }, {
                      default: _withCtx(() => [
                        _createTextVNode("广告支出")
                      ]),
                      _: 1
                    })
                  ]))
                : ((scope.record as any).type === 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_component_a_tag, { color: "purple" }, {
                        default: _withCtx(() => [
                          _createTextVNode("广告消耗")
                        ]),
                        _: 1
                      })
                    ]))
                  : ((scope.record as any).type === 4)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createVNode(_component_a_tag, { color: "cyan" }, {
                          default: _withCtx(() => [
                            _createTextVNode("购买反现")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
        ]),
        wallet: _withCtx(({ scope }) => [
          _createElementVNode("span", {
            style: _normalizeStyle({
          color: (scope.record as any).wallet >= 0 ? '#52c41a' : '#8c8c8c',
          fontWeight: 500,
        })
          }, _toDisplayString((scope.record as any).wallet > 0
              ? "+"
              : (scope.record as any).wallet < 0 ? "-" : "") + "$" + _toDisplayString(Math.abs((scope.record as any).wallet)), 5)
        ]),
        userInfo: _withCtx(({ scope }) => [
          _createElementVNode("div", null, _toDisplayString((scope.record as any).userName || "-"), 1),
          ((scope.record as any).userId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " ID:" + _toDisplayString((scope.record as any).userId), 1))
            : _createCommentVNode("", true)
        ]),
        remark2: _withCtx(({ scope }) => [
          _createVNode(_component_a_tooltip, {
            title: (scope.record as any).remark2 || ''
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, _toDisplayString((scope.record as any).remark2 || "-"), 1)
            ]),
            _: 2
          }, 1032, ["title"])
        ]),
        verify: _withCtx(({ scope }) => [
          ($setup.showWalletAudit(scope.record))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ((scope.record as any).verify === 0)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "orange"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("待核验")
                      ]),
                      _: 1
                    }))
                  : ((scope.record as any).verify === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_a_tag, { color: "green" }, {
                          default: _withCtx(() => [
                            _createTextVNode("已经核验")
                          ]),
                          _: 1
                        }),
                        ($setup.walletVerifyNumberLine((scope.record as any).number))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.walletVerifyNumberLine((scope.record as any).number)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : ((scope.record as any).verify === 2)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 2,
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("核验错误")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12))
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_13))
        ]),
        action: _withCtx(({ scope }) => [
          ($setup.showWalletAudit(scope.record))
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                onClick: ($event: any) => ($setup.openCheckDialog(scope.record as any))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("审核")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_14))
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        "page-size": $setup.pageSize,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "page-size", "onShowSizeChange"])
    ]),
    _createVNode(_component_x_dialog, {
      title: "钱包明细审核",
      visible: $setup.checkDialogVisible,
      loading: $setup.checkLoading,
      onConfirm: $setup.confirmCheck,
      onCancel: _cache[8] || (_cache[8] = ($event: any) => ($setup.checkDialogVisible = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.checkFormState,
          "label-col": { span: 5 },
          "wrapper-col": { span: 19 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "密码",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: $setup.checkFormState.password,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($setup.checkFormState.password) = $event)),
                  placeholder: "6位纯数字财务密码",
                  maxlength: "6"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "编号",
              required: $setup.checkFormState.verify === 1
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.checkFormState.number,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($setup.checkFormState.number) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请输入编号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["required"]),
            _createVNode(_component_a_form_item, {
              label: "财务核验",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $setup.checkFormState.verify,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($setup.checkFormState.verify) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("已经核验")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("核验错误")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "loading", "onConfirm"])
  ], 64))
}